"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isCompositeTypeElement = exports.isDOMTypeElement = exports.isElement = exports.isReactComponent = exports.isFunctionComponent = exports.isClassComponent = exports.isPositiveNum = exports.isEN = exports.isCN = exports.isWechat = exports.isQQ = exports.isPassword = exports.isUsername = exports.isEmail = exports.isMobilePhone = exports.isPhone = exports.isAllNumber = exports.isNumber = exports.isHttpLink = exports.isSomething = exports.isNoneContain = exports.isContain = exports.isSubset = exports.isValue = exports.isSameArr = exports.isUrl = exports.isProd = exports.isDev = exports.isArray = exports.isObj = exports.isBoolean = exports.isNum = exports.isStr = exports.isFunction = void 0;
var react_1 = __importDefault(require("react"));
function isFunction(obj) {
    return typeof obj === 'function';
}
exports.isFunction = isFunction;
function isStr(str) {
    return typeof str === 'string';
}
exports.isStr = isStr;
function isNum(str) {
    return typeof str === 'number';
}
exports.isNum = isNum;
function isBoolean(str) {
    return typeof str === 'boolean';
}
exports.isBoolean = isBoolean;
function isObj(obj) {
    return typeof obj === 'object';
}
exports.isObj = isObj;
function isArray(arr) {
    return Array.isArray(arr);
}
exports.isArray = isArray;
var isDev = function () {
    var NODE_ENV = process.env.NODE_ENV;
    return NODE_ENV === 'development';
};
exports.isDev = isDev;
var isProd = function () {
    var NODE_ENV = process.env.NODE_ENV;
    return NODE_ENV === 'production';
};
exports.isProd = isProd;
var isUrl = function (path) {
    var reg = /(((^https?:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9.-]+(?::\d+)?|(?:www.|[-;:&=\+\$,\w]+@)[A-Za-z0-9.-]+)((?:\/[\+~%\/.\w-_]*)?\??(?:[-\+=&;%@.\w_]*)#?(?:[\w]*))?)$/;
    return reg.test(path);
};
exports.isUrl = isUrl;
// 检查数组内容是否完全一样
var isSameArr = function (arr1, arr2) {
    if (arr1 === void 0) { arr1 = []; }
    if (arr2 === void 0) { arr2 = []; }
    var totalLen = __spreadArray([], __read(new Set(__spreadArray(__spreadArray([], __read(arr1)), __read(arr2))))).length;
    return __spreadArray([], __read(new Set(arr1))).length === totalLen && __spreadArray([], __read(new Set(arr2))).length === totalLen;
};
exports.isSameArr = isSameArr;
var isValue = function (value, emptyArrOrObj) {
    if (value === undefined || value === null) {
        return false;
    }
    if (isStr(value) && value.trim() === '') {
        return false;
    }
    if (isArray(value) && !value.length && !emptyArrOrObj) {
        return false;
    }
    if (isObj(value) && Object.keys(value).length === 0 && !emptyArrOrObj) {
        return false;
    }
    if (value === 0) {
        return true;
    }
    return !!value;
};
exports.isValue = isValue;
var isSubset = function (total, check) {
    return Array.from(new Set(__spreadArray(__spreadArray([], __read(total)), __read(check)))).length === total.length;
};
exports.isSubset = isSubset;
var isContain = function (list, checked) {
    return list.filter(function (item) { return checked.indexOf(item) !== -1; }).length === list.length;
};
exports.isContain = isContain;
var isNoneContain = function (list, checked) {
    return list.filter(function (item) { return checked.indexOf(item) !== -1; }).length === 0;
};
exports.isNoneContain = isNoneContain;
/* eslint no-useless-escape:0 */
function isSomething(pattern, some) {
    return pattern.test(some);
}
exports.isSomething = isSomething;
function isHttpLink(path) {
    var reg = /^(https?):\/\/[-A-Za-z0-9+&@#/%?=~_|!:,.;]+[-A-Za-z0-9+&@#/%=~_|]/;
    return isSomething(reg, path);
}
exports.isHttpLink = isHttpLink;
function isNumber(c) {
    var reg = /^[0-9]+$/;
    return isSomething(reg, c);
}
exports.isNumber = isNumber;
function isAllNumber(c) {
    var reg = /(^[\-0-9][0-9]*(\.[0-9]+)?)$/;
    // const reg = /^(([^0][0-9]+|0)\.([0-9]{1,2})$)|^([^0][0-9]+|0)$/
    return isSomething(reg, c);
}
exports.isAllNumber = isAllNumber;
function isPhone(phone) {
    var regPhone = /^(1[0-9]{2})\d{8}$/;
    var regFixed = /(\(\d{3,4}\)|\d{3,4}-|\s)?\d{8}/; // 固话
    return isSomething(regPhone, phone) || isSomething(regFixed, phone);
}
exports.isPhone = isPhone;
function isMobilePhone(phone) {
    var regPhone = /^(1[0-9]{2})\d{8}$/;
    return isSomething(regPhone, phone);
}
exports.isMobilePhone = isMobilePhone;
function isEmail(email) {
    var reg = /^([a-zA-Z0-9]+[_|\_|\.|\-]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\_|\.|\-]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,5}$/;
    return isSomething(reg, email);
}
exports.isEmail = isEmail;
function isUsername(name) {
    var reg = /^[a-zA-Z0-9_-]{1,}$/;
    return isSomething(reg, name);
}
exports.isUsername = isUsername;
// 校验密码强度 rank = enum { 0, 1, 2} 强度递增， 默认最低
function isPassword(pass, rank) {
    if (rank === void 0) { rank = 0; }
    // 非空且大于等于6位即可
    var reg0 = /^\S{6,}$/;
    // 至少6-16个字符，至少1个大写字母，1个小写字母和1个数字，其他可以是任意字符
    var reg1 = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[^]{6,16}$/;
    // 最短4位，最长16位 {6,16}
    // 必须包含1个数字
    // 必须包含1个小写字母
    // 必须包含1个大写字母
    // 必须包含1个特殊字符
    var reg2 = /^.*(?=.{4,16})(?=.*\d)(?=.*[A-Z]{1,})(?=.*[a-z]{1,})(?=.*[!@#$%^&*?\(\)]).*$/;
    switch (rank) {
        case 0:
            return isSomething(reg0, pass);
        case 1:
            return isSomething(reg1, pass);
        case 2:
            return isSomething(reg2, pass);
        default:
            return isSomething(reg0, pass);
    }
}
exports.isPassword = isPassword;
function isQQ(qq) {
    var reg = /^[1-9][0-9]{4,10}$/;
    return isSomething(reg, qq);
}
exports.isQQ = isQQ;
function isWechat(we) {
    var reg = /^[a-zA-Z]([-_a-zA-Z0-9]{5,19})+$/;
    return isSomething(reg, we);
}
exports.isWechat = isWechat;
// 排除全部为英文的字符串
function isCN(c) {
    var reg = /^[\w\s]{0,}$/;
    return !isSomething(reg, c);
}
exports.isCN = isCN;
function isEN(c) {
    var reg = /^[^\u4e00-\u9fa5]{0,}$/;
    return isSomething(reg, c);
}
exports.isEN = isEN;
function isPositiveNum(c) {
    var reg = /^[0-9]+.?[0-9]*$/;
    return isSomething(reg, c);
}
exports.isPositiveNum = isPositiveNum;
function isClassComponent(component) {
    return (typeof component === 'function' &&
        !!component.prototype.isReactComponent);
}
exports.isClassComponent = isClassComponent;
function isFunctionComponent(component) {
    return (typeof component === 'function' &&
        String(component).includes('return React.createElement'));
}
exports.isFunctionComponent = isFunctionComponent;
function isReactComponent(component) {
    return (isClassComponent(component) ||
        isFunctionComponent(component));
}
exports.isReactComponent = isReactComponent;
function isElement(element) {
    return react_1.default.isValidElement(element);
}
exports.isElement = isElement;
function isDOMTypeElement(element) {
    return isElement(element) && typeof element.type === 'string';
}
exports.isDOMTypeElement = isDOMTypeElement;
function isCompositeTypeElement(element) {
    return isElement(element) && typeof element.type === 'function';
}
exports.isCompositeTypeElement = isCompositeTypeElement;
